import { React, useEffect, useState, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import { Layout } from 'antd';
import { NavBar, Space, Button, Popup, List, AutoCenter } from 'antd-mobile';
import liff from '@line/liff';
import MobileRouter from './../../router/MobileRouter';
import { useNavigate } from 'react-router-dom';
import { MenuOutlined } from '@ant-design/icons';
import { WebviewAuthValid } from 'shared/webviewHttpHandler';
import secureStorage from '../../shared/secureStorage';

const ScrollToTop = ({ scrollEleRef }) => {
  const { pathname } = useLocation();

  useEffect(() => {
    if (scrollEleRef.current) {
      scrollEleRef.current.scrollTop = 0;
    }
  }, [pathname]);

  return null;
};

const MobileHome = () => {
  let navigate = useNavigate();
  const { Header, Content, Footer } = Layout;

  const contentRef = useRef(null);
  const [menuVisible, setMenuVisible] = useState(false);
  const rightContent = <></>;
  // const rightContent = // 打開側邊菜單的按鈕
  //   (
  //     <Space>
  //       <Button
  //         fill="none"
  //         onClick={() => {
  //           setMenuVisible(true);
  //         }}>
  //         <MenuOutlined />
  //       </Button>
  //     </Space>
  //   );

  const [lineUserId, setLineUserId] = useState();
  // 取得line user id
  const getLineUserId = () => {
    const liffId = process.env.REACT_APP_ENTRANCE_LIFF_ID;

    if (!liffId) {
      console.error('環境變數 REACT_APP_ENTRANCE_LIFF_ID 不存在');
      return;
    } else if (liffId === 'USE_FAKE_LIFF') {
      secureStorage.setItem('displayName', null);
      secureStorage.setItem('pictureUrl', null);
      secureStorage.setItem('lineUserId', 'U29d0df7ceb6ad41f28933ab1c2530b65');
      setLineUserId('U29d0df7ceb6ad41f28933ab1c2530b65');
      return;
    } else {
      return new Promise((resolve, reject) => {
        liff
          .init({ liffId: process.env.REACT_APP_ENTRANCE_LIFF_ID })
          .then(() => {
            // 如果用戶尚未登入，引導用戶登入
            if (!liff.isLoggedIn()) {
              liff.login({ redirectUri: window.location.href });
            }
            // 取得用戶資訊並設定line user id
            liff
              .getProfile()
              .then((profile) => {
                // 存進localStorage
                setLineUserId(profile.userId);
                secureStorage.setItem('displayName', profile.displayName);
                secureStorage.setItem('pictureUrl', profile.pictureUrl);
                secureStorage.setItem('lineUserId', profile.userId);
                resolve(profile);
              })
              .catch(reject);
          })
          .catch(reject);
      });
    }
  };
  useEffect(() => {
    WebviewAuthValid.clearAuth();
    getLineUserId();
  }, []);
  if (!lineUserId) {
    return <div>載入中...</div>;
  }
  return (
    <div className="mobile">
      <Layout className="mobile-home" theme="light">
        <Header className="home-header">
          <NavBar
            className="home-header-navbar"
            right={rightContent}
            backArrow={false}>
            <img
              src="/images/logo/easyrent.svg"
              alt="Logo"
              style={{ height: '24px' }}
            />
          </NavBar>
        </Header>
        <Content
          className="home-content"
          ref={contentRef}
          style={{ scrollBehavior: 'smooth' }}>
          <ScrollToTop scrollEleRef={contentRef} />
          <MobileRouter />
          <Footer className="footer-background">
            <AutoCenter>© 和運租車股份有限公司</AutoCenter>
          </Footer>
        </Content>
      </Layout>
      <Popup
        visible={menuVisible}
        onMaskClick={() => {
          setMenuVisible(false);
        }}
        position="right"
        bodyStyle={{ width: '60vw' }}>
        <div style={{ height: '100vh', overflowY: 'scroll' }}>
          <List header="功能清單">
            <List.Item
              onClick={() => {
                navigate('/m');
              }}>
              空白首頁
            </List.Item>
            <List.Item
              onClick={() => {
                navigate('/m/Bind/SelectType');
              }}>
              選擇綁定身份
            </List.Item>
            <List.Item
              onClick={() => {
                navigate('/m/Bind/Individual');
              }}>
              個人會員綁定
            </List.Item>
            <List.Item
              onClick={() => {
                navigate('/m/Bind/Corporate');
              }}>
              企業會員綁定
            </List.Item>
            <List.Item
              onClick={() => {
                navigate('/m/Bind/Sales');
              }}>
              業代會員綁定
            </List.Item>
            <List.Item
              onClick={() => {
                navigate('/m/Bind/IndividualSuccess');
              }}>
              個人會員綁定成功
            </List.Item>
            <List.Item
              onClick={() => {
                navigate('/m/Bind/CorporateSuccess');
              }}>
              企業會員綁定成功
            </List.Item>
            <List.Item
              onClick={() => {
                navigate('/m/Bind/SalesSuccess');
              }}>
              業代會員綁定成功
            </List.Item>
            <List.Item
              onClick={() => {
                navigate('/m/Car/CarList');
              }}>
              車輛查詢列表
            </List.Item>
            <List.Item
              onClick={() => {
                navigate('/m/Car/CarInfo');
              }}>
              車輛詳情
            </List.Item>
            <List.Item
              onClick={() => {
                navigate('/m/Car/CarInfo/FineTicket');
              }}>
              車輛詳情-罰單
            </List.Item>
            <List.Item
              onClick={() => {
                navigate('/m/Car/CarInfo/ParkingFee');
              }}>
              車輛詳情-停車費
            </List.Item>
            <List.Item
              onClick={() => {
                navigate('/m/Car/CarInfo/ETag');
              }}>
              車輛詳情-eTag
            </List.Item>
            <List.Item
              onClick={() => {
                navigate('/m/Car/CarInfo/Maintenance');
              }}>
              車輛詳情-保養預約
            </List.Item>
            <List.Item
              onClick={() => {
                navigate('/m/Car/CarInfo/Inspection');
              }}>
              車輛詳情-驗車預約
            </List.Item>
            <List.Item
              onClick={() => {
                navigate('/m/Car/CarInfo/Appointment');
              }}>
              車輛詳情-預約記錄
            </List.Item>
            <List.Item
              onClick={() => {
                navigate('/m/Car/CarInfo/ConsultantInfo');
              }}>
              車輛詳情-洽詢服專
            </List.Item>
            <List.Item
              onClick={() => {
                navigate('/m/Car/CarInfo/SalesInfo');
              }}>
              車輛詳情-洽詢業代
            </List.Item>
            <List.Item
              onClick={() => {
                navigate('/m/BusinessCard');
              }}>
              名片
            </List.Item>
            <List.Item
              onClick={() => {
                navigate('/m/RecommendProject');
              }}>
              推薦專案
            </List.Item>
            <List.Item
              onClick={() => {
                navigate('/m/CommonQuestion');
              }}>
              常見問題
            </List.Item>
            <List.Item
              onClick={() => {
                navigate('/m/PreferenceQuestionnaire');
              }}>
              用車喜好問卷
            </List.Item>
            <List.Item
              onClick={() => {
                navigate('/m/PreferenceQuestionnaireSuccess');
              }}>
              用車喜好問卷-填寫成功
            </List.Item>
            <List.Item
              onClick={() => {
                navigate('/m/Chat');
              }}>
              聊天室
            </List.Item>
          </List>
        </div>
      </Popup>
    </div>
  );
};

export default MobileHome;
